// import { change, actionTypes } from 'redux-form/immutable';

export default ({ dispatch }) => next => action => {
  // if (action.type === actionTypes.UNREGISTER_FIELD) {
  //   dispatch(change(action.meta.form, action.payload.name, null));
  // }
  next(action);
};
